import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511993706525', '_blank');
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-gray-900">
              <span style={{ fontFamily: '"Pacifico", serif' }}>Investigação Confidencial</span>
            </h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#sinais" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
              Sinais de Alerta
            </a>
            <a href="#processo" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
              Como Funciona
            </a>
            <a href="#sigilo" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
              Sigilo Garantido
            </a>
            <div className="flex items-center text-gray-700 text-sm">
              <i className="ri-phone-line mr-2 text-red-600"></i>
              <span>(11) 99370-6525</span>
            </div>
            <Button onClick={handleWhatsAppClick} size="sm">
              Consulta Confidencial
            </Button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-red-600 transition-colors"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#sinais" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Sinais de Alerta
              </a>
              <a href="#processo" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Como Funciona
              </a>
              <a href="#sigilo" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Sigilo Garantido
              </a>
              <div className="flex items-center text-gray-700 text-sm">
                <i className="ri-phone-line mr-2 text-red-600"></i>
                <span>(11) 99370-6525</span>
              </div>
              <Button onClick={handleWhatsAppClick} size="sm" className="w-full">
                Consulta Confidencial
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
